import type { FaireProductEntity } from "../../entity_types/product";

export const p_jjwq44ubqh: FaireProductEntity = {
  token: "p_jjwq44ubqh",
  type: "product",
  name: "Waffle Tea Towel - Potluck",
  brandToken: "b_btb379emrh",
  brandName: "Mel Andrel",
  imageUrl: "https://cdn.faire.com/fastly/68c4afb74569d712f7d1b714d7f558175161bdb0fe48a75f19ff8cd130c129ce.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/684060949e4d305ba19be6824818f32d7a2dc7925b88b1d87dfa1ffa56cffe17.jpeg",
    "https://cdn.faire.com/fastly/fd2c50f424ee61d799ac1d77895f4628b5055b1ce6cbcb2ca7ffad200b2428a6.jpeg",
    "https://cdn.faire.com/fastly/620190a9e4486aec1b47efa83103af3c7247bf42c57c161f94e437abf1a84715.jpeg",
    "https://cdn.faire.com/fastly/4d7924722c581f3591dacdb5777e14af35fcd6164e054e714decb353237676f8.jpeg"
  ],
  priceDollars: 11,
  description: "A high quality waffle towel great for food wrapping and kitchen decor. \n\nGood to know:\n\n * Waffle knit \n * Packaged in cotton ribbon bellyband with info card. \n * Measures 20in x 20in \n * 100% organic cotton ",
  tags: [],
  msrpDollars: 22,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-06T18:33:07.581Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
